import React, { FC, PropsWithChildren } from 'react';
import styles from '@/core/assets/scss/components/ResponsiveFixedButtons.module.scss';

const ResponsiveFixedButtons: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles['responsive-fixed-button']}>{children}</div>;
};

export default ResponsiveFixedButtons;
